export const getUserTypeColor = (userType: 'renter' | 'owner' | 'captain' | string) => {
  if (userType === 'owner') return '#0e7873';
  if (userType === 'captain') return '#00677d';
  return '#0751c2';
};

export const getUserTypeFromIs = ({ isCaptain, isOwner, isRenter }) => {
  if (isOwner) return 'owner';
  if (isCaptain) return 'captain';
  if (isRenter) return 'renter';
  return 'renter';
};
